import { AxiosResponse } from 'axios';
import axiosInstance from './axios';

export const getRegistryMethodologyPlatforms = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/registry_methodology');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching registry methodology platforms: ${errorMessage}`);
  }
};

export const createRegistryMethodologyPlatform = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/registry_methodology', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating registry methodology platform: ${errorMessage}`);
  }
};
